import { MPIN_TABLE_DATA, MPIN_TABLE_DATA_FAILURE, MPIN_TABLE_DATA_REQUEST, MPIN_TABLE_DATA_SUCCESS } from '../actionTypes';

export const fetchDdpApiDataRequest = (payload: any) => ({
      type: MPIN_TABLE_DATA_REQUEST,
      payload,
});
export const fetchDdpDataSuccess = (payload: any) => ({
      type: MPIN_TABLE_DATA_SUCCESS,
      payload
});
export const fetchDdpDataError = (payload: any) => ({
      type: MPIN_TABLE_DATA_FAILURE,
      payload
});
export const getDppData = (payload: any) => ({
      type: MPIN_TABLE_DATA,
      payload
});





